import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import ServiceAutomobile from "./pages/ServiceAutomobile";
import ServiceInterieur from "./pages/ServiceInterieur";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/service-automobile" element={<ServiceAutomobile />} />
          <Route path="/service-interieur" element={<ServiceInterieur />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
